import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import ResetPassword from '../components/auth/ResetPassword';
import GlobalScrollToTop from '../components/common/GlobalScrollToTop';
import GlobalCheckInPrompt from '../components/common/GlobalCheckInPrompt';
import logo from '../assets/logo.png';
import IdleWarningModalResponsive from '../components/system/IdleWarningModalResponsive';
import AuthenticatedAppShell from './AuthenticatedAppShell';
import { AuthContainer, AuthCard, Logo } from './App.styles';
import coreRoutes from './authenticatedRoutes/coreRoutes';
import adminRoutes from './authenticatedRoutes/adminRoutes';
import instructorRoutes from './authenticatedRoutes/instructorRoutes';
import studentRoutes from './authenticatedRoutes/studentRoutes';

// The full authenticated route table, split by domain into
// coreRoutes/adminRoutes/instructorRoutes/studentRoutes (same files,
// same order as the original single-file route list - just data
// instead of inline JSX). React Router supports rendering an array of
// <Route> elements from a config array; each still needs a `key`.
const allRoutes = [...coreRoutes, ...adminRoutes, ...instructorRoutes, ...studentRoutes];

function AuthenticatedRoutes({ sidebarOpen, setSidebarOpen, idleTimer, handleAutoLogout }) {
  return (
    <>
    <Routes>
        {/* Special route for reset password - always shows in auth layout */}
        <Route path="/reset-password" element={
          <AuthContainer>
            <AuthCard
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Logo>
                <img src={logo} alt="Faith Insight Logo" />
                <h1>Faith Insight</h1>
                <p>Learning Portal</p>
              </Logo>
              <ResetPassword />
            </AuthCard>
          </AuthContainer>
        } />

        {/* All other authenticated routes */}
        <Route path="*" element={
          <AuthenticatedAppShell sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}>
              <Suspense fallback={
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }} aria-label="Loading">
                  <div style={{
                    width: '40px',
                    height: '40px',
                    border: '4px solid var(--border-color)',
                    borderTop: '4px solid var(--primary-color)',
                    borderRadius: 0,
                    animation: 'spin 1s linear infinite'
                  }} />
                </div>
              }>
                <Routes>
                    {allRoutes.map(({ path, element }) => (
                      <Route key={path} path={path} element={element} />
                    ))}
                  </Routes>
              </Suspense>
          </AuthenticatedAppShell>
        } />
      </Routes>

      {/* Global Scroll-to-Top FAB - Single instance for entire app */}
      <GlobalScrollToTop />

      {/* Global Check-In Reminder - prompts students to check in for a live
          check-in window they're enrolled in but haven't completed yet,
          regardless of which page they're on */}
      <GlobalCheckInPrompt />

      {/* Idle Warning Modal */}
      <IdleWarningModalResponsive
        open={idleTimer.warningVisible}
        logoutAtMs={idleTimer.logoutAtMs}
        onStay={idleTimer.stayLoggedIn}
        onLogout={handleAutoLogout}
      />
    </>
  );
}

export default AuthenticatedRoutes;
